
import React from 'react';
import { motion } from 'framer-motion';
import { Control } from 'react-hook-form';
import { RegistrationFormValues } from '@/schemas/registrationSchema';
import { TShirtSizeSelector } from '@/components/registration';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shirt } from 'lucide-react';

interface TShirtSectionProps {
  control: Control<RegistrationFormValues>;
}

const TShirtSection: React.FC<TShirtSectionProps> = ({ control }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, duration: 0.5 }}
      className="w-full"
    >
      <Card className="overflow-hidden border border-blue-100 shadow-md bg-gradient-to-br from-white to-blue-50">
        <CardHeader className="bg-gradient-to-r from-blue-600 to-indigo-500 py-4">
          <CardTitle className="text-white flex items-center space-x-2 text-lg">
            <Shirt className="w-5 h-5 animate-pulse" />
            <span>Áo T-shirt sự kiện</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-5 pb-6">
          <p className="text-sm text-blue-700 mb-5 bg-blue-50 p-3 rounded-lg border border-blue-100">
            Mỗi người đăng ký sẽ được tặng một áo T-shirt kỷ niệm sự kiện.
            Vui lòng chọn kích thước áo phù hợp với bạn.
          </p>
          <TShirtSizeSelector control={control} />
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default TShirtSection;
